import { LoginSchema, SignUpSchema, loginSchema, signUpSchema } from "@/features/auth/schemas";
import { LoginResponse, SignupResponse } from "@/features/auth/types/responses";
import { badRequest } from "@/shared/lib/utils/errors";
import http from "@/shared/lib/utils/http";
import { toErrorDetails } from "@/shared/lib/utils/zod";

export async function signUp(values: SignUpSchema): Promise<string> {
  const validationResult = signUpSchema.safeParse(values);

  if (!validationResult.success) {
    throw badRequest("Signup", toErrorDetails(validationResult.error));
  }

  const formBody = new URLSearchParams();

  formBody.append("first_name", values.firstName.trim());
  formBody.append("last_name", values.lastName.trim());
  formBody.append("email_address", values.emailAddress.trim());
  formBody.append("password", values.password);
  formBody.append("confirm_password", values.confirmPassword);

  const response = await http.post<SignupResponse>({
    url: "/auth/signup",
    contentType: "application/x-www-form-urlencoded",
    body: formBody.toString(),
  });

  return response.access_token;
}

export async function login(values: LoginSchema): Promise<string> {
  const validationResult = loginSchema.safeParse(values);

  if (!validationResult.success) {
    throw badRequest("Login", toErrorDetails(validationResult.error));
  }

  const formBody = new URLSearchParams();

  formBody.append("email_address", values.emailAddress.trim());
  formBody.append("password", values.password);

  const response = await http.post<LoginResponse>({
    url: "/auth/login",
    contentType: "application/x-www-form-urlencoded",
    body: formBody.toString(),
  });

  return response.access_token;
}
